import axios from 'axios'
import { authZeroFetch } from './AuthZeroFetch'

const GetIncomeWithEvent = (
    clientId,
    startEventAge,
    endEventAge,
    coverageLevel,
    taxType,
    duration,
    hideGroup,
    hideGroupStd,
    hideIndividual,
    hideCat
) => {
    return authZeroFetch(axios.get, '/api/charts/income/' + clientId + '/scenarios', {
        params: {
            startEventAge,
            endEventAge,
            coverageLevel,
            taxType,
            duration,
            hideGroup,
            hideGroupStd,
            hideIndividual,
            hideCat,
        },
    })
}

const GetPlanComparison = (clientId, taxType, duration, hideBasicCat, hideModCat, hideCompCat) => {
    return authZeroFetch(axios.get, '/api/charts/plans/' + clientId, {
        params: {
            taxType,
            duration,
            hideBasicCat,
            hideModCat,
            hideCompCat,
        },
    })
}

const GetAssetComparisonChart = (clientId) => {
    return authZeroFetch(axios.get, '/api/charts/assets/' + clientId)
}

const GetPresentationHeaders = (clientId) => {
    return authZeroFetch(axios.get, '/api/charts/headers/' + clientId)
}

const GetAssetComparisonSeparate = (clientId) => {
    return authZeroFetch(axios.get, '/api/charts/assets/' + clientId + '/separate')
}

const GetAssetCostComparison = (clientId, coverageLevel, duration, showCat) => {
    return authZeroFetch(axios.get, '/api/charts/assets/' + clientId + '/costcomparison', {
        params: {
            coverageLevel: coverageLevel,
            duration: duration,
            includeCat: showCat === 'Yes',
        },
    })
}

const GetCurrentCoverage = (clientId, taxType, duration) => {
    return authZeroFetch(axios.get, '/api/charts/coverage/' + clientId, {
        params: {
            taxType: taxType,
            duration: duration,
        },
    })
}

const GetIncomeAssetChart = (clientId) => {
    return authZeroFetch(axios.get, '/api/charts/income/' + clientId)
}

export {
    GetIncomeAssetChart,
    GetIncomeWithEvent,
    GetPlanComparison,
    GetCurrentCoverage,
    GetAssetComparisonChart,
    GetAssetComparisonSeparate,
    GetAssetCostComparison,
    GetPresentationHeaders,
}
